import {Inject, Injectable} from 'ng-metadata/core';
import {
    getAttributesMap,
    getBackendSystem,
    getInstitutionCode,
    getResultsBulkSize
} from "../../appConfig/appConfigForward";
import {Cheetah} from "../cheetah.service";
import {MappingTablesCache} from "../../mappingTablesCache/mappingTablesCache.service";
import {CollectionDiscoveryService} from "../../collectionDiscovery/collectionDiscovery.service";

const forEach = require('lodash/forEach');
const get = require('lodash/get');

@Injectable()
export class MoreLikeThisService {
    public searchInProgress: boolean;
    public itemsSearchInProgress: boolean;
    public nextOffset: Object = {};
    public totalItems: Object = {};
    public moreLikeThisItems: Object = {};

    constructor(private collectionDiscoveryService: CollectionDiscoveryService,
                private cheetah: Cheetah,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$state') private $state: angular.ui.IStateService,
                @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService) {

    }

    public getItemsForSameField(item: any, searchQuery ?: string, offset: number = 0): Promise<any> {
        // let institution= inst || getInstitutionCode();
        let q = "";
        let type = 'any';
        if (searchQuery === 'crs') {
            type = 'crsid';
        } else if (searchQuery === 'col') {
            type = 'cdparentid';
        }


        let args = {
            offset: offset,
            bulkSize: getResultsBulkSize(),
            mode: 'advanced'
            // overrideViewInstitution: institution
        };


        let moreFromSameItems: string[] = [];
        if (searchQuery === 'crs') {
            args.scope = this.$stateParams['search_scope'] || 'browse_search';
            if (get(item, 'pnx.search.crsid')){
                moreFromSameItems = get(item, 'pnx.search.crsid');
            } else {
                let courses = this.getDataFromCourseItem(item);
                courses.forEach(element => {
                    moreFromSameItems.push(element.courseCodeAndSection);
                  });
            }
        } else if (searchQuery === 'col') {
            args.scope = getBackendSystem() !== 'suprima' ? 'collection_discovery_search' : 'browse_search';
            if (get(item, 'pnx.search.cdparentid')){
                moreFromSameItems = get(item, 'pnx.search.cdparentid')
            } else {
                moreFromSameItems = this.getCollectionIds(item);
            }
        }

        forEach(moreFromSameItems, (crs) => {
            q += type + ',exact,' + crs + ',OR;';
        });

        args.query = q;

        if (searchQuery) {
            args.mode = 'advanced';
        }
        let res = this.cheetah.performSearch(args);
        return res;
        //return this.cheetah.performSearch(args);
    }

    public getCollectionIds(item){
        let collectionIds: string[] = [];
        let collections = this.collectionDiscoveryService.getDataFromCollectionRecord(item);
        collections.forEach(element => {
            collectionIds.push(element.collectionId);
          });
        return collectionIds;
    }

    public getDataFromCourseItem(item: PrimoResponse.IDoc) : {courseId, courseCodeAndSection, courseName}{
        let crsinfo = get(item, 'pnx.display.crsinfo');
        let courseSection = "";
        if (crsinfo) {
            return crsinfo.map((field) => {
                let dataMap;
                if (field) {
                    dataMap = {};
                    let splittedArr = field.split('$$');
                    for (let s of splittedArr) {
                        let data = s.substring(1);
                        switch (s.charAt(0)) {
                            case 'R':
                                dataMap['courseId'] = data;
                                break;
                            case 'M':
                                dataMap['courseName'] = data;
                                break;
                            case 'N':
                                courseSection = data;
                                break;
                        }
                    }
                }
                dataMap['courseCodeAndSection'] = dataMap['courseId'] + '.' + courseSection;
                return dataMap;
            });
        }
    }

    public getItemFullViewParams(moreLikeThisItem) {
        if (!moreLikeThisItem) {
            return undefined;
        }
        let params = angular.copy(this.$location.search());
        if (getBackendSystem() === 'suprima' && this.$state.current.name === 'servicesPage') {
            params['rft.mms_id'] = get(moreLikeThisItem, 'pnx.control.recordid', '').replace('alma', '');
            params.rft_dat = 'ie=';
            params.ie = undefined;
        } else {
            params.docid = get(moreLikeThisItem, 'pnx.control.recordid');
        }
        return params;
    }

    public navigateToItemFullView(moreLikeThisItem) {
        let params = this.$location.search();
        if (getBackendSystem() === 'suprima' && this.$state.current.name === 'servicesPage') {
            params['rft.mms_id'] = get(moreLikeThisItem, 'pnx.control.recordid', '').replace('alma', '');
            params.rft_dat = 'ie=';
            params.ie = undefined;
            this.$state.go('servicesPage', params, {reload: true});
        } else if (getBackendSystem() === 'suprima' && (this.$state.current.name === 'jfulldisplay' || this.$state.current.name === 'exploreMain.jsearch')) {
            params.docid = get(moreLikeThisItem, 'pnx.control.recordid');
            this.$state.go('jfulldisplay', params, {reload: true});
        } else {
            params.docid = get(moreLikeThisItem, 'pnx.control.recordid');
            this.$state.go('fulldisplay', params, {reload: true});
        }
        this.$mdDialog.hide();
    }

    public getStateName() {
        switch (this.$state.current.name) {
            case 'exploreMain.search':
                return 'fulldisplay';
            case 'exploreMain.jsearch':
                return 'jfulldisplay';
            default :
                return this.$state.current.name;
        }

    }

    public parseResponse(data, item) {
        let items = get(data, 'data.docs') || get(data, 'docs');
        items = items.filter((rec) => get(item, 'pnx.control.recordid[0]') !== get(rec, 'pnx.control.recordid[0]'));
        return items;
    }
   
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/moreLikeThis/moreLikeThis.service.ts